import { Application } from '@hotwired/stimulus'
import { definitionsFromContext } from '@hotwired/stimulus-webpack-helpers'

window.Stimulus = Application.start()

window.Stimulus.load([
  ...definitionsFromContext(
    require.context('../controllers/core', false, /\.js$/)
  ),
  ...definitionsFromContext(
    require.context('../controllers/components', false, /\.js$/)
  ),
  ...definitionsFromContext(
    require.context('../controllers/views', false, /\.js$/)
  ),
])
